import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import styles from './styles.module.less';

import type { BannerMessageV2Props } from 'ui-components/components/banner-message/banner-message-v2-types';

export const Banner = (props: BannerMessageV2Props) => {
  return <BannerMessageV2 {...props} className={styles.banner} />;
};
